import { videoIdMedium } from './videoIdMedium.js'
import {videoIdSubstantial} from './videoIdSubstantial.js'

const SERVICES = {
  videoIdMedium,
  videoIdSubstantial
}

export async function initializeSignicatService(config, chat){
  const { sdkUrl, service, lang, documentTypes } = config
  const serviceInstance = await SERVICES[service](sdkUrl, config.authorizationToken, lang, documentTypes, chat)
}